import _ from 'lodash';

export default class User {
  constructor(data) {
    const defaults = {
      authenticated: false,
      msisdn: null,
      packet: null,
      saldo: null,
      discount: {},
      serviceClass: null,
      serviceClassGroup: null,
      inactivePackets: [],
      canPurchasePacket: true,
      saldoPossibleToLoad: 200,
      validFrom: null,
      validUntil: null,
      pauseMode: false,
    };
    data = _.merge(defaults, data);
    this.authenticated = data.authenticated;
    this.msisdn = data.msisdn;
    this.packet = data.packet;
    this.saldo = data.saldo;
    if (this.saldo !== null) {
      this.saldo /= 100;
    }
    this.saldoPossibleToLoad = data.saldoPossibleToLoad;
    this.serviceClass = data.serviceClass;
    this.serviceClassGroup = data.serviceClassGroup;
    this.inactivePackets = data.inactivePackets;
    this.canPurchasePacket = data.canPurchasePacket;
    this.discount = data.discount;
    this.validFrom = data.validFrom;
    this.validUntil = data.validUntil;
    this.pauseMode = data.pauseMode;
  }

  get formattedMsisdn() {
    const regex = /^\+?\d{3}(\d{2})(\d{3})(\d{4})$/;
    const parts = this.msisdn.match(regex);
    return `0${parts[1]} ${parts[2]} ${parts[3]}`;
  }

  applySaldoDiscount(saldo) {
    if (
      this.discount.topupMin !== null &&
      this.discount.saldoDiscount !== null &&
      this.discount.topupMin / 100 <= saldo
    ) {
      console.log(saldo - this.discount.saldoDiscount / 100);
      return saldo - this.discount.saldoDiscount / 100;
    }
    return saldo;
  }
}
